<template>
  <div class="home" :style="{ height: height }">
    <template v-if="$store.state.ui.os.isPC">
      <div style="display: flex;justify-content: center;align-items: center;height: calc(50% - 80px);">
        <div style="background-color: white;display: flex;justify-content: center;align-items: center;height: 100%;width: 30%;">
          <img :src="require('@/assets/images/logo_plune.png')" alt="" style="width: 50%;" />
        </div>
      </div>
      <div style="display: flex;flex-direction: row;margin-top: 12px;justify-content: center;">
        <v-btn dark large class="text-capitalize mr-2" min-width="230" @click="toPage(0)">
          傘のオーダーを開始
        </v-btn>
      </div>
    </template>
    <template v-else>
      <div style="display: flex;justify-content: center;align-items: center;height: calc(50% - 80px);background-color: white;">
        <img :src="require('@/assets/images/logo_plune.png')" alt="" style="width: 30%;">
      </div>
      <div style="display: flex;flex-direction: column;margin-top: 12px;">
        <v-btn dark large class="text-capitalize mx-auto mb-2" min-width="230" @click="toPage(0)">
          傘のオーダーを開始
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: window.innerHeight + 'px',
      list: [
        '/umb',
        '/scarf',
        '/cap'
      ]
    }
  },
  mounted () {
  },
  methods: {
    toPage (index) {
      this.$store.state.ui.homeIndex = index
      this.$router.push(this.list[index])
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  background-color: white;
  padding: 12px;
}
</style>
